import LocationSelector from './location-selector';
export default LocationSelector;